// UI strings for the stress check (StressView): which syllable sounded strongest in your own
// recording, compared with where High Valyrian puts the stress. Finnish first; en has the same shape.
// Placeholders {pos}, {right} and {heard} are filled by StressView ({right}/{heard} become HV words).
import { defineArea } from '../area';

export const stressCheckFi = {
  title: 'Paino äänityksessäsi',
  note: 'Automaattinen vihje, ei arvosana. Se voi erehtyä – Petersonin äänite on aina malli.',
  expectedMark: 'Paino kuuluu tälle tavulle',
  heard: 'vahvin',
  barsLabel: 'Palkki näyttää, kuinka vahvasti tavu erottui: sävelkorkeus, voimakkuus ja kesto yhdessä.',
  ok: 'Paino osui oikealle tavulle.',
  unsure: 'Tästä sanasta ei saatu varmaa tulosta.',
  none: 'Äänityksestä ei saatu painoa esiin. Puhu hieman hitaammin ja lähempänä mikrofonia, niin yritetään uudelleen.',
  singles: 'Yksitavuisissa sanoissa ei ole painoa tarkistettavana.',
  tipInitial: 'Painotit ensimmäistä tavua, kuten suomessa. Korkeavalyriassa paino on {pos} tavulla: {right}, ei {heard}.',
  tipOther: 'Paino on {pos} tavulla: {right}, ei {heard}.',
  /** Syllable positions counted from the end: last, second-to-last, third-to-last. */
  fromEnd: ['viimeisellä', 'toiseksi viimeisellä', 'kolmanneksi viimeisellä'],
  first: 'ensimmäisellä',
  summary: (expected: string, heard: string) => `Odotettu paino: ${expected}. Vahvimpana kuului: ${heard}.`,
};

export const stressCheckEn: typeof stressCheckFi = {
  title: 'Stress in your recording',
  note: 'An automatic hint, not a grade. It can be wrong – Peterson’s recording is always the model.',
  expectedMark: 'The stress belongs on this syllable',
  heard: 'strongest',
  barsLabel: 'Each bar shows how strongly the syllable stood out: pitch, loudness and length together.',
  ok: 'The stress landed on the right syllable.',
  unsure: 'No reliable result for this word.',
  none: 'The stress could not be made out in this recording. Speak a little slower and closer to the microphone, then try again.',
  singles: 'Words of one syllable have no stress to check.',
  tipInitial: 'You stressed the first syllable, as in Finnish. In High Valyrian the stress is on {pos} syllable: {right}, not {heard}.',
  tipOther: 'The stress is on {pos} syllable: {right}, not {heard}.',
  fromEnd: ['the last', 'the second-to-last', 'the third-to-last'],
  first: 'the first',
  summary: (expected: string, heard: string) => `Expected stress: ${expected}. Strongest in your recording: ${heard}.`,
};

// Messages.stressCheck (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('stressCheck', stressCheckFi, stressCheckEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof stressCheckFi> {}
}
